export const RAW_JSON_VIEWER_CLASS_NAME =
  'overflow-auto rounded-lg border border-gray-200 bg-white p-4 font-mono text-xs leading-5 text-gray-800';

export function RawJsonViewer({ value }: Readonly<{ value: unknown }>) {
  return (
    <pre className={RAW_JSON_VIEWER_CLASS_NAME}>
      {formatRawJson(value)}
    </pre>
  );
}

export function formatRawJson(value: unknown): string {
  const serialized = JSON.stringify(value, null, 2);
  return serialized ?? 'null';
}
